/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/actionService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * Action列表
 */
export function getActionData(Info) {
  return request({
    url:
      "/api/v1/actions?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Action页面数据
 */
export function createAction(data) {
  return request({
    url: "/api/v1/actions",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Action页面数据
 */
export function editAction(data) {
  return request({
    url: "/api/v1/actions/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Action数据详情
 */
export function getActionInfo(id) {
  return request({
    url: "/api/v1/actions/" + id,
    method: "GET"
  });
}
/*
 * 删除Action数据
 */
export function deleteAction(id) {
  return request({
    url: "/api/v1/actions/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/actionService.js